export function ErrorPage({
	error,
	resetError,
}: {
	error: unknown;
	resetError: () => void;
}) {
	return (
		<div className="min-h-screen flex flex-col bg-background">
			<div className="flex-1 flex items-center justify-center">
				<div className="max-w-sm w-full p-6 bg-card text-card-foreground rounded-lg shadow">
					<h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
					<p className="text-sm text-muted-foreground mb-6">
						An unexpected error occurred. You can try again or go back to the
						home page.
					</p>
					{error instanceof Error && error.message && (
						<pre className="text-xs text-muted-foreground bg-muted rounded p-3 mb-6 overflow-auto max-h-32">
							{error.message}
						</pre>
					)}
					<div className="flex flex-col gap-3">
						<button
							type="button"
							onClick={resetError}
							className="inline-flex items-center justify-center rounded-md text-sm font-medium h-10 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90"
						>
							Try again
						</button>
						<a
							href="/"
							className="inline-flex items-center justify-center rounded-md text-sm font-medium h-10 px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground"
						>
							Go home
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
